import { Injectable, inject } from "@angular/core";
import { AppSessionService } from "@vadmin/account/auth";
import { CoreFeatures } from "@app/wapps/core/feature-names";
import { PermissionName } from "@app/wapps/core/permissions-name";
import { isSncrFeatureEnabled } from "./sncr/sncr.model";

const ASAAS_INTEGRATION_SETTING = "System.Payment.AsaasIntegrationEnabled";

@Injectable({
    providedIn: "root",
})
export class IntegrationAccessService {
    private readonly _appSession = inject(AppSessionService);

    allowAccessToWebHooks(): boolean {
        return this._mayManageIntegrations() && abp.features.isEnabled(CoreFeatures.Webhooks);
    }

    allowAccessToGoogle(): boolean {
        return abp.features.isEnabled(CoreFeatures.ScheduleGoogleIntegration) && this._appSession.isDoctor();
    }

    allowAccessToAsaas(): boolean {
        return (
            this._mayManageIntegrations() &&
            abp.setting.getBoolean(ASAAS_INTEGRATION_SETTING) &&
            abp.features.isEnabled(CoreFeatures.VPay)
        );
    }

    allowAccessToSncr(): boolean {
        return isSncrFeatureEnabled() && (this._appSession.isAdmin() || this._appSession.isDoctor());
    }

    private _mayManageIntegrations(): boolean {
        return abp.auth.isGranted(PermissionName.ManageIntegrations);
    }

    isMenuEnabled(): boolean {
        return (
            (this.allowAccessToWebHooks() ||
                this.allowAccessToGoogle() ||
                this.allowAccessToAsaas() ||
                this.allowAccessToSncr()) &&
            abp.auth.isAnyGranted(
                PermissionName.Integrations,
                PermissionName.IntegrationsQuery,
                PermissionName.GoogleCalendarIntegration,
                PermissionName.ManageIntegrations
            )
        );
    }
}
